export const stats = [
  { value: "98%", label: "College Acceptance Rate" },
  { value: "1550+", label: "Average SAT Score" },
  { value: "2,400+", label: "Students Placed" },
  { value: "15+", label: "Years of Excellence" },
];

export const services = [
  {
    icon: "ri-book-open-line",
    title: "SAT / ACT Test Prep",
    description: "Structured programs with proven strategies to maximize your score. Personalized study plans, full-length practice tests, and expert feedback.",
    color: "from-amber-50 to-orange-50",
    accent: "#D97706",
  },
  {
    icon: "ri-user-star-line",
    title: "1-on-1 Tutoring",
    description: "Private sessions with elite tutors who attended top universities. Tailored pacing, instant feedback, and focused skill-building.",
    color: "from-emerald-50 to-teal-50",
    accent: "#059669",
  },
  {
    icon: "ri-group-line",
    title: "Online Group Classes",
    description: "Collaborative learning in small cohorts of 6–10 students. Peer motivation, live instruction, and structured curriculum.",
    color: "from-rose-50 to-pink-50",
    accent: "#E11D48",
  },
  {
    icon: "ri-file-text-line",
    title: "Essay Writing Coaching",
    description: "Craft compelling college essays that stand out. From brainstorming to final polish — we help your authentic voice shine.",
    color: "from-violet-50 to-purple-50",
    accent: "#7C3AED",
  },
  {
    icon: "ri-compass-3-line",
    title: "College Application Strategy",
    description: "Build a smart, balanced college list. We guide you through every step — from school selection to application timelines.",
    color: "from-sky-50 to-cyan-50",
    accent: "#0284C7",
  },
  {
    icon: "ri-trophy-line",
    title: "Scholarship Guidance",
    description: "Identify and apply for merit and need-based scholarships. We help you secure funding so your dream school is within reach.",
    color: "from-yellow-50 to-amber-50",
    accent: "#B45309",
  },
];

export const courses = [
  {
    id: 1,
    title: "SAT Math Mastery",
    subtitle: "Algebra, Advanced Math & Problem Solving",
    level: "Grades 9–12",
    sessions: "24 Sessions",
    rating: 4.9,
    reviews: 312,
    price: "$1,200",
    tag: "Best Seller",
    image: "https://public.readdy.ai/ai/img_res/4c572752cf5eccc71d6333ad5fdd4ea0.jpg",
  },
  {
    id: 2,
    title: "SAT Reading & Writing",
    subtitle: "Evidence-Based Reading, Grammar & Expression",
    level: "Grades 9–12",
    sessions: "20 Sessions",
    rating: 4.8,
    reviews: 278,
    price: "$1,100",
    tag: "Popular",
    image: "https://readdy.ai/api/search-image?query=cheerful%20blonde%20teenage%20boy%20student%20with%20sandy%20blonde%20hair%20reading%20books%20and%20writing%20notes%20in%20bright%20modern%20library%20clean%20white%20background%20happy%20academic%20focused%20atmosphere%20bright%20smile&width=400&height=280&seq=course2blond&orientation=landscape",
  },
  {
    id: 3,
    title: "Ivy League Essay Bootcamp",
    subtitle: "Common App, Supplements & Scholarship Essays",
    level: "Grades 11–12",
    sessions: "12 Sessions",
    rating: 5.0,
    reviews: 189,
    price: "$980",
    tag: "New",
    image: "https://readdy.ai/api/search-image?query=smiling%20blonde%20university%20student%20girl%20with%20wavy%20golden%20hair%20writing%20college%20application%20essay%20on%20laptop%20at%20modern%20clean%20desk%20soft%20warm%20lighting%20minimal%20white%20background%20focused%20academic%20environment&width=400&height=280&seq=course3blond&orientation=landscape",
  },
  {
    id: 4,
    title: "College Admissions Strategy",
    subtitle: "School Selection, Timeline & Application Planning",
    level: "Grades 10–12",
    sessions: "10 Sessions",
    rating: 4.9,
    reviews: 224,
    price: "$850",
    tag: "Top Rated",
    image: "https://readdy.ai/api/search-image?query=happy%20blonde%20university%20student%20boy%20with%20light%20blonde%20hair%20reviewing%20university%20brochures%20and%20application%20materials%20at%20bright%20clean%20office%20desk%20professional%20academic%20setting%20excited%20expression&width=400&height=280&seq=course4blond&orientation=landscape",
  },
];

export const teachers = [
  {
    id: 1,
    name: "Dr. Sarah Mitchell",
    title: "SAT Math Expert",
    school: "Harvard University, PhD Mathematics",
    experience: "12 years",
    students: "800+",
    rating: 4.98,
    image: "https://readdy.ai/api/search-image?query=professional%20female%20teacher%20educator%20smiling%20confidently%20in%20a%20bright%20clean%20studio%20background%20academic%20professional%20portrait%20warm%20lighting&width=300&height=360&seq=teacher1&orientation=portrait",
  },
  {
    id: 2,
    name: "James Thornton",
    title: "College Admissions Counselor",
    school: "Yale University, MA Education",
    experience: "10 years",
    students: "650+",
    rating: 4.97,
    image: "https://readdy.ai/api/search-image?query=professional%20male%20college%20counselor%20educator%20smiling%20in%20a%20bright%20clean%20studio%20background%20academic%20professional%20portrait%20warm%20lighting&width=300&height=360&seq=teacher2&orientation=portrait",
  },
  {
    id: 3,
    name: "Emily Chen",
    title: "Essay Writing Coach",
    school: "Princeton University, MFA Writing",
    experience: "8 years",
    students: "500+",
    rating: 4.99,
    image: "https://readdy.ai/api/search-image?query=professional%20female%20writing%20coach%20educator%20smiling%20warmly%20in%20a%20bright%20clean%20studio%20background%20academic%20professional%20portrait%20natural%20lighting&width=300&height=360&seq=teacher3&orientation=portrait",
  },
  {
    id: 4,
    name: "Marcus Williams",
    title: "ACT & SAT Verbal Specialist",
    school: "Columbia University, MA English",
    experience: "9 years",
    students: "720+",
    rating: 4.96,
    image: "https://readdy.ai/api/search-image?query=professional%20male%20tutor%20educator%20smiling%20confidently%20in%20a%20bright%20clean%20studio%20background%20academic%20professional%20portrait%20warm%20natural%20lighting&width=300&height=360&seq=teacher4&orientation=portrait",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Olivia Harrison",
    school: "Admitted to Harvard University",
    grade: "Class of 2024",
    score: "SAT 1580",
    avatar: "https://readdy.ai/api/search-image?query=smiling%20blonde%20teenage%20girl%20student%20portrait%20clean%20white%20background%20natural%20lighting%20cheerful%20academic%20setting%20long%20golden%20blonde%20hair%20blue%20eyes%20bright%20smile&width=80&height=80&seq=avatar1blond&orientation=squarish",
    quote: "Crown SAT completely transformed my approach to the SAT. I went from a 1320 to a 1580 in just 4 months. My counselor helped me craft an essay that truly reflected who I am — and Harvard noticed.",
  },
  {
    id: 2,
    name: "Ethan Kowalski",
    school: "Admitted to MIT",
    grade: "Class of 2024",
    score: "SAT 1590",
    avatar: "https://readdy.ai/api/search-image?query=smiling%20blonde%20teenage%20boy%20student%20portrait%20clean%20white%20background%20natural%20lighting%20happy%20academic%20setting%20sandy%20blonde%20hair%20bright%20smile%20university%20student&width=80&height=80&seq=avatar2blond&orientation=squarish",
    quote: "The 1-on-1 math tutoring was incredible. My tutor broke down every concept until it clicked. I never thought I'd score a 790 on Math, but here I am — heading to MIT this fall!",
  },
  {
    id: 3,
    name: "Sophie Beaumont",
    school: "Admitted to Yale University",
    grade: "Class of 2025",
    score: "SAT 1570",
    avatar: "https://readdy.ai/api/search-image?query=smiling%20blonde%20french%20teenage%20girl%20student%20portrait%20clean%20white%20background%20natural%20lighting%20happy%20academic%20golden%20wavy%20blonde%20hair%20bright%20cheerful%20smile&width=80&height=80&seq=avatar3blond&orientation=squarish",
    quote: "As a student from France, I was nervous about applying to US universities. Crown SAT guided me through every step — from test prep to visa paperwork. I got into Yale with a full scholarship!",
  },
  {
    id: 4,
    name: "Liam O'Brien",
    school: "Admitted to Stanford University",
    grade: "Class of 2025",
    score: "ACT 35",
    avatar: "https://readdy.ai/api/search-image?query=smiling%20blonde%20irish%20teenage%20boy%20student%20portrait%20clean%20white%20background%20natural%20lighting%20happy%20academic%20setting%20light%20blonde%20hair%20freckles%20bright%20smile&width=80&height=80&seq=avatar4blond&orientation=squarish",
    quote: "The college application strategy sessions were a game-changer. My counselor helped me build the perfect school list and position my application. Stanford was a reach — and I got in!",
  },
];

export const successSchools = [
  "Harvard", "MIT", "Yale", "Stanford", "Princeton",
  "Columbia", "UPenn", "Cornell", "Dartmouth", "Brown",
  "Oxford", "Cambridge", "LSE", "UCL", "Imperial College",
];
